import { type FC, type ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { Label, LabelVariants } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';

export const CommentShowMoreSeparator: FC<{
  onClick: () => void;
  disabled: boolean;
  dataCy?: string;
  loading: boolean;
  children?: ReactNode;
  className?: string;
}> = ({ onClick, disabled, dataCy = 'comment-show-more-replies', loading, children, className }) => {
  return (
    <button
      type="button"
      className={cn(
        'group/load-replies flex cursor-pointer! items-center gap-2 pl-12 pr-3 focus-within:outline-0 focus-within:bg-black/4 dark:focus-within:bg-white/4',
        className,
      )}
      onClick={onClick}
      disabled={disabled}
      data-cy={dataCy}
    >
      <Separator className="h-px flex-1 bg-ui-separator!" />

      {loading ? (
        <Loader2 className="icon-4 animate-spin text-text-gray-alternate" strokeWidth={2} />
      ) : (
        <Label
          variant={LabelVariants.INSPECTOR_SECTION}
          className="mb-0 cursor-[inherit] duration-150 group-hover/load-replies:text-text-gray"
        >
          {children}
        </Label>
      )}

      <Separator className="h-px flex-1 bg-ui-separator!" />
    </button>
  );
};
